import React, { useEffect, useState } from 'react';
import { get } from 'lodash';
import Logo from '../assets/images/logo.png';
import { Button, Card, Col, Form, Input, message, Row, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { resetPassword } from '@/store/actions/authenticate';
import { useHistory, useLocation } from 'react-router-dom';
import moment from 'moment';
const { Text } = Typography;

export default function ResetPassword() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const query = new URLSearchParams(useLocation().search);
  const token = query.get('token');
  const [state, setState] = useState({});
  const [isError, setIsError] = useState(false);
  const [passwordValidation, setPasswordValidation] = useState({
    characters: false,
    lowercase: false,
    uppercase: false,
    number: false,
    special: false,
  });

  const stateAuthenticate = useSelector((global_state) => global_state.authenticate);
  const staff_id = get(stateAuthenticate, ['user', 'staff_id']);
  const email = get(stateAuthenticate, ['user', 'email']);

  useEffect(() => {
    try {
      if (token) {
        const data = JSON.parse(decodeURIComponent(escape(window.atob(token))));
        if (moment().toDate() < moment(moment.utc(data.expire_time).toDate()).local().toDate()) {
          setState(data);
        } else {
          setIsError(true);
        }
      }
    } catch (e) {
      setIsError(true);
    }
  }, [token]);

  const onFinish = (value) => {
    if (Object.values(passwordValidation).includes(false)) return;
    setIsLoading(true);
    dispatch(
      resetPassword({ ...value, staff_id, email }, (error) => {
        if (!error) {
          history.push('/login');
          message.success(
            'Your password has been reset successfully.  Please login using your new password.',
            6,
          );
          return;
        }
        setIsLoading(false);
        const errMessage = Object.values(error.error?.response?.data?.details || {})?.[0];
        message.error(
          errMessage || error.error?.response?.data?.message || 'Something went wrong!',
        );
      }),
    );
  };

  return (
    <div className="login-page">
      <Row align="middle" justify="center" className="wrapper">
        <Col xs={24} sm={12} md={8} className="login-form">
          <Card>
            <img className="logo" alt="PETstock New Zealand logo" src={Logo} />
            {isError && (
              <Row justify="center">
                <Text type="danger">Your password reset link has expired</Text>
              </Row>
            )}
            <Form
              form={form}
              name="basic"
              initialValues={{ remember: true }}
              className="form-content"
              onFinish={onFinish}
              layout="vertical"
              requiredMark={false}
              onValuesChange={({ new_password }) => {
                if (new_password !== undefined)
                  setPasswordValidation({
                    characters: new_password.length >= 8,
                    lowercase: /[a-z]/.test(new_password),
                    uppercase: /[A-Z]/.test(new_password),
                    number: /[0-9]/.test(new_password),
                    special: /[@#$!*]/.test(new_password),
                  });
              }}
            >
              <Form.Item
                labelAlign="left"
                label="New Password"
                name="new_password"
                rules={[{ required: true, message: 'Please input your new password!' }]}
              >
                <Input.Password />
              </Form.Item>

              <Row>
                <Text>Password must:</Text>
              </Row>
              <ul className="password-requirement">
                <li className={passwordValidation.characters ? 'checked' : ''}>
                  Be a minimum of 8 characters
                </li>
                <li className={passwordValidation.lowercase ? 'checked' : ''}>
                  Include at least one lowercase letter (a-z)
                </li>
                <li className={passwordValidation.uppercase ? 'checked' : ''}>
                  Include at least one uppercase letter (A-Z)
                </li>
                <li className={passwordValidation.number ? 'checked' : ''}>
                  Include at least one number (0-9)
                </li>
                <li className={passwordValidation.special ? 'checked' : ''}>
                  Include at least one special symbol (@#$!*)
                </li>
              </ul>

              <Form.Item
                labelAlign="left"
                label="Confirm Password"
                name="confirm_new_password"
                rules={[{ required: true, message: 'Please input your confirm password!' }]}
              >
                <Input.Password />
              </Form.Item>

              <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Button loading={isLoading} size="large" htmlType="submit" disabled={isError}>
                  Continue
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
